import { render } from "./ImpressaoCautela.vue?vue&type=template&id=40e37015&scoped=true"
import script from "./ImpressaoCautela.vue?vue&type=script&lang=js"
export * from "./ImpressaoCautela.vue?vue&type=script&lang=js"

import "./ImpressaoCautela.vue?vue&type=style&index=0&id=40e37015&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e37015"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QPageSticky,QBtn});
